export default __webpack_public_path__ + "static/media/e3bd2470-4bb0-4d18-ac8c-3cd2d4e591f6.23a8736d.JPG";